/*
 *
 * WidgetChartEnps reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DATA_ENPS_WATCHER,
  GET_DATA_ENPS_SUCCESS,
  GET_DATA_ENPS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  getDataEnps: null,
})

function widgetChartEnpsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DATA_ENPS_WATCHER:
      return state.set("isLoading", true).set("dataEnps", null)

    case GET_DATA_ENPS_SUCCESS:
      return state.set("isLoading", false).set("dataEnps", action.payload)

    case GET_DATA_ENPS_FAILED:
      return state.set("isLoading", false).set("dataEnps", null)

    default:
      return state
  }
}

export default widgetChartEnpsReducer
